import { render, staticRenderFns } from "./EntryMessageRegisterConfirm.vue?vue&type=template&id=0d96c202"
import script from "./EntryMessageRegisterConfirm.vue?vue&type=script&lang=js"
export * from "./EntryMessageRegisterConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports